<template>
  <div>
    <!-- {{languageMode}} -->
    <!--Edit by ankit-->
    <a
      class="mdc-list-item d-flex justify-content-between align-items-center"
      @click="toggleLanguageSelect()"
      :class="[{
        'mdc-list-item__active': getCurrentTab()
      }]"
    >
      <span class="drawer-icon-size material-icons mdc-list-item__graphic">
        <span class="material-icons navi-icons" :class="{ 'mdc-list-item__active__text': getCurrentTab()}">local_activity</span>
      </span>
      <div class="flex-grow-1">
        {{ $t("S10036") }}
      </div>

      <!-- 언어선택 -->
      <i class="material-icons">
        {{ openCategory === "activity" ? "expand_less" : "expand_more" }}
      </i>
    </a>
    <!-- <transition name="slide"> -->
    <div v-if="openCategory === 'activity'">
      <router-link
        class="mdc-list-item"
        to="/member/myinfo"
        style="color: #212121"
        :class="{
          'mdc-list-item__active__text': getCurrentRoute('/member/myinfo'),
        }"
      >
        <i class="material-icons mdc-list-item__graphic"></i>
        {{ $t("2044") }}
      </router-link>
      <router-link
        class="mdc-list-item"
        to="/leader"
        style="color: #212121"
        :class="{ 'mdc-list-item__active__text': getCurrentRoute('/leader') }"
      >
        <i class="material-icons mdc-list-item__graphic"></i>
        {{ $t("2000") }}
      </router-link>
      <router-link
        class="mdc-list-item"
        to="/portfolio"
        style="color: #212121"
        :class="{
          'mdc-list-item__active__text': getCurrentRoute('/portfolio'),
        }"
      >
        <i class="material-icons mdc-list-item__graphic"></i>
        {{ $t("2030") }}
      </router-link>
      <router-link
        class="mdc-list-item"
        to="/point"
        style="color: #212121"
        :class="{ 'mdc-list-item__active__text': getCurrentRoute('/point') }"
      >
        <i class="material-icons mdc-list-item__graphic"></i>
        {{ $t("2039") }}
      </router-link>
      <router-link
        class="mdc-list-item"
        to="/rewardcertificatelist"
        style="color: #212121"
        :class="{
          'mdc-list-item__active': getCurrentRoute('/rewardcertificatelist'),
        }"
      >
        <i class="material-icons mdc-list-item__graphic"></i>
        {{ $t("2012") }}
      </router-link>
      <router-link
        class="mdc-list-item"
        to="/rewardbadgelist"
        style="color: #212121"
        :class="{
          'mdc-list-item__active': getCurrentRoute('/rewardbadgelist'),
        }"
      >
        <i class="material-icons mdc-list-item__graphic"></i>
        {{ $t("2013") }}
      </router-link>
      <router-link
        class="mdc-list-item"
        to="/prize-request"
        style="color: #212121"
        :class="{
          'mdc-list-item__active__text': getCurrentRoute('/prize-request'),
        }"
      >
        <i class="material-icons mdc-list-item__graphic"></i>
        {{ $t("S20036") }}
      </router-link>
    </div>
    <!-- </transition> -->
  </div>
</template>

<script>
/**
 * 네비게이션 드로워 언어 목록 컴포넌트(navigation drawer language list Components)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { mapState, mapMutations } from "vuex";

export default {
  props: ["openCategory"],
  data() {
    return {
      isElearningSelect: false,
      categoryList: [],
      linkList: [
        "/member/myinfo",
        "/leader",
        "/portfolio",
        "/point",
        "/rewardcertificatelist",
        "/rewardbadgelist",
        "/prize-request",
      ],
    };
  },

  computed: {
    ...mapState(["languageMode"]),
  },

  mounted() {
    let params = {
      brandCode: localStorage.getItem("brandCode"),
    };
  },

  methods: {
    ...mapMutations(["SET_LANGUAGE_MODE"]),
    // 언어 목록 토글(toggle language list)
    toggleLanguageSelect() {
      this.isElearningSelect = !this.isElearningSelect;
      this.handleCategory();
    },
    handleCategory() {
      this.$emit("handleCategory", this.isElearningSelect ? "activity" : null);
    },
    // 언어 변경(change language)
    changeLanguage(lang) {
      //setUserLanguage(lang.code).then(() => {
      this.$emit("closeDrawer");
      //})
    },
    getCurrentTab() {
      const fullPath = this.$route.fullPath.toLowerCase();
      return this.linkList.some(link => fullPath.includes(link));
    },
    getCurrentRoute(item) {
      const isCurrentRoute = item === this.$route.path;
      return isCurrentRoute;
    },
  },
};
</script>
<style scoped>
.mdc-list-item {
  color: #818181 !important;
  text-decoration: none !important;
}
.mdc-list-item-active {
  color: #2d6dcc !important;
}
.mdc-list-item::before {
  background: none !important;
}
.mdc-list-item::after {
  background: none !important;
}
.mdc-list-item__active {
  color: #2d6dcc !important;
}
.mdc-list-item__active__text {
  color: #2d6dcc !important;
}
</style>